import { computed } from 'vue';
import { useAccount } from './useAccount';

export function useCallingMinutesQuota() {
  const { currentAccount } = useAccount();

  const remainingMinutes = computed(() => {
    const dim = currentAccount.value?.limits?.calling_minutes;
    if (!dim || dim.allowed == null) return null;
    const remaining = dim.remaining ?? dim.allowed - (dim.consumed ?? 0);
    return Math.max(0, remaining);
  });

  const minutesExhausted = computed(() => {
    if (remainingMinutes.value == null) return false;
    return remainingMinutes.value <= 0;
  });

  return { minutesExhausted, remainingMinutes };
}
